import { checkIsBusinessUser } from "selectors/user";
import { getCurrentQuickBooksRealmId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import AdvancedTransactionTypes from "const/AdvancedTransactionTypes";
import DatePickerInput from "nlib/common/DatePickerInput";
import Dates from "utils/Dates";
import DocumentTypes from "const/DocumentTypes";
import FieldContainer from "../FieldContainer";
import React, { useCallback } from "react";
import moment from "moment";
import useDateFormatter from "hooks/useDateFormatter";
import useDocumentContext from "hooks/useDocumentContext";

const IssueDateField = (props) => {
  const id = "issueDate";

  const dateFormatter = useDateFormatter();

  const { uiTexts } = useSelector(getTextsData);

  const quickBooksBusiness = !!useSelector(getCurrentQuickBooksRealmId);

  const businessUser = useSelector(checkIsBusinessUser);

  const {
    documentState: { [id]: value, type, exportAs },
    setDocumentState
  } = useDocumentContext();

  const label = quickBooksBusiness && type === DocumentTypes.RECEIPT && exportAs === AdvancedTransactionTypes.EXPENSE
    ? uiTexts.paymentDate
    : uiTexts.issueDate;

  const placeholder = quickBooksBusiness && type === DocumentTypes.RECEIPT && exportAs === AdvancedTransactionTypes.EXPENSE
    ? uiTexts.enterPaymentDate
    : uiTexts.enterIssueDate;

  const handleChange = useCallback((newValue) => {
    setDocumentState({ [id]: newValue });
  }, [setDocumentState]);

  return (
    <FieldContainer
      portal
      id={id}
      confidenceFields={["issueDate"]}
      label={label}
      placeholder={placeholder}
      invalid={!businessUser
        && (!value || moment(value).isAfter(moment(Dates.formatNoTimeZoneDate(new Date(), false))))}
      value={value}
      displayValue={value ? dateFormatter(value) : null}
      onChange={handleChange}
      component={DatePickerInput}
      {...props} />
  );
};

export default React.memo(IssueDateField);
